import DraggableCore from 'react-draggable';
import { useState } from 'react';
import ProfileCanvas from './ProfileCanvas';

const ProfilePreview = ({
  previewHeight,
  scale,
  onRepositionCompleted,
  onRepositionStarted,
  isVisible,
  sizes,
  profileImage,
  canvasSize,
}) => {
  const profilePreview = document.getElementById('profile-preview');
  const previewWidth = profilePreview?.offsetWidth;
  const translateShift = (previewWidth * (scale - 1)) / 2;

  const [profileUrl, setProfileUrl] = useState(undefined);

  return (
    <>
      <ProfileCanvas
        {...sizes}
        profileImage={profileImage}
        onDraw={setProfileUrl}
        canvasSize={canvasSize}
      />
      <div
        className="z-10 relative"
        style={{
          height: `${previewHeight}px`,
          transform: `translate(${translateShift}px, ${translateShift}px) scale(${scale})`,
        }}
      >
        <DraggableCore
          onStop={(_, data) => onRepositionCompleted(data)}
          onStart={onRepositionStarted}
        >
          <div className="w-full m-auto overflow-hidden">
            <div
              id="profile-preview"
              className="opacity-100 bg-no-repeat w-full h-full m-auto bg-left-top bg-contain"
              style={{
                height: `${previewHeight}px`,
                backgroundImage: `url(${profileUrl})`,
              }}
            />
          </div>
        </DraggableCore>
      </div>
      <div
        className={`z-0 relative bg-black w-full overflow-hidden rounded-full pointer-events-none ${
          !isVisible && 'invisible'
        }`}
        style={{
          top: `-${previewHeight}px`,
          height: `${previewHeight}px`,
        }}
      />
    </>
  );
};

export default ProfilePreview;
